import {
  OneClickHaulersActions,
  OneClickHaulersActionTypes,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-hauler.actions';
import { IHauler } from '@cemex-core/cmx-api';

export interface OneClickHaulersState {
  loading: boolean;
  haulersAvailable: IHauler[];
  selected: IHauler;
}

export const initialState: OneClickHaulersState = {
  loading: false,
  haulersAvailable: [],
  selected: null,
};

export function reducer(state = initialState, action: OneClickHaulersActions): OneClickHaulersState {
  switch (action.type) {
    case OneClickHaulersActionTypes.LOAD_HAULERS: {
      return {
        ...state,
        loading: true,
      } as OneClickHaulersState;
    }
    case OneClickHaulersActionTypes.LOAD_HAULERS_COMPLETE: {
      return {
        ...state,
        loading: false,
        haulersAvailable: action.payload,
      } as OneClickHaulersState;
    }
    case OneClickHaulersActionTypes.SELECT_HAULER: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickHaulersState;
    }
    case OneClickHaulersActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
